import React from 'react';

const AdminTestPage = () => {
    return (
        <div>
            
        </div>
    );
};

export default AdminTestPage;

// import React, {useEffect, useState} from 'react';
// import Modal from "../../../../components/modal/modal";
// import TestModal from "./modal/create/test-modal";
// import {ITags} from "../../../public/test_page/TestPage";
// import {baseUrl} from "../../../../constants/constants";
// import {INews} from "../../adminPage";
//
// const AdminTestPage = () => {
//     const [showModal, setShowModal] = useState(false);
//     const [tags, setTags] = useState<ITags[]>([])
//     const [news, setNews] = useState<INews[]>([])
//
//     const closeModal = () => {
//         setShowModal(false)
//     }
//
//     useEffect(() => {
//         fetch(`${baseUrl}tags`)
//             .then((res) => res.json())
//             .then((data) => setTags(data))
//     }, []);
//
//     useEffect(() => {
//         fetch(`${baseUrl}news?sort_date=true&is_archive=false`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setNews(data);
//             })
//             .catch((err) => {
//                 console.log(err);
//             });
//     },[])
//
//     return (
//         <section>
//             <button onClick={() => setShowModal(true)}>
//                 Добавить новость
//                 {showModal &&
//                     <Modal active={showModal} title={'Добавить новость'} сlose={closeModal}>
//                         <TestModal close={closeModal} tags={tags}/>
//                     </Modal>
//                 }
//             </button>
//
//             {/*<div>*/}
//             {/*    {news.map((i) => (*/}
//             {/*        <TestNewsList news={news} />*/}
//             {/*    ))}*/}
//             {/*</div>*/}
//         </section>
//     );
// };
//
// export default AdminTestPage;